import React from "react";
import { useSelector } from "react-redux";

function BrandingFooter() {
  const {whitelabelEnabled} = useSelector((state)=>state.miscSlice)
  return (
    // left-1/2 transform -translate-x-1/2
    <div className={` flex items-center justify-center space-x-1 bg-transparent ${ whitelabelEnabled
          ? "bg-[#FAF9F6] text-slate-900"
          : "bg-gray-900 text-white "}`}>
      <span
        className={` text-sm ${
          whitelabelEnabled ? "text-gray-600" : "text-gray-300"
        }`}
      >
        Powered by 
      </span>
      {/* Need To Change Logo Here  */}
      <span
        className={` text-sm ${
          whitelabelEnabled ? "text-gray-600" : "text-gray-300"
        }`}
      >
      geniehire.ai
      </span>
      
    </div>
  );
}

export default BrandingFooter;
